import { render, staticRenderFns } from "./STextField.vue?vue&type=template&id=b6b70b48&scoped=true&lang=pug"
import script from "./STextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./STextField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./STextField.vue?vue&type=style&index=0&id=b6b70b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b70b48",
  null
  
)

export default component.exports